<template>
  <div class="home">
    <!-- 视频部分 -->
    <div class="videoDiv">
      <video loop="loop" controls="" muted="" preload="auto" autoplay="" :src="homeData.banner_video"></video>
    </div>
    <!-- 广告banner部分 -->
    <div class="guangaoDiv">
      <el-carousel height="99vh" arrow="always">
        <el-carousel-item v-for="(item,index) in homeData.guangao_bannsers" :key="index">
          <el-image
            :src="item"
            fit="contain"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 产品优势等等链接轮播 -->
    <div class="linkDiv">
      <el-carousel height="99vh" arrow="always">
        <el-carousel-item  v-for="(item,index) in homeData.comp_banners" :key="index">
          <div class="bgDiv">
            <img style="cursor: pointer" :src="$fileDPath+item.compBannersImg" @click="$router.push(item.compBannersPath)"/>
            <h2 class="tit">
              <p>{{ item.compBannersName }}</p>
            </h2>
            <div class="desc">
              <p>{{ item.compBannersDesc }}</p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 五行奇门 -->
    <div class="wuxinDiv" style="background-image: url(static/menhu/images/wuxin_bg.webp)">
      <el-row :gutter="10" style="width: 100%;height: 100%">
        <el-col :md="14" class="hidden-sm-and-down circle" style="height: 100%">
          <div class="wrapper">
            <img class="center" src="static/menhu/images/wuxin_main.png" />
            <div class="circle-logo">
              <img src="static/menhu/images/wuxin_logo.png" alt="">
            </div>
            <div class="run run1">
              <ul>
                <li @mouseover="changeGoodLink(item.typeID)" v-for="(item,index) in homeData.goods_banner" :key="index" :class="'backrun item item-'+(index+1)">
                  <a href="#">
                    <span>{{ item.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :md="10"  style="height: 100%;">
          <div class="goodsTypeShowDiv">
            <p class="show_title">{{ nowShowGood.title }}</p>
            <img class="show_img"  :src="nowShowGood.images"/>
            <p class="show_desc">{{ nowShowGood.desc }}</p>
            <el-button @click.prevent="toRouter('goodsType');" class="show_btn" type="primary" plain>开启梦想之门 →</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 了解梵蒂斯 -->
    <div class="ljFantisDiv" style="background-image: url(static/menhu/images/vantis_fan_bg.jpg)">
      <img class="lj_img" src="static/menhu/images/vantis_fan.png" />
      <p class="lj_title">为居者打造梦想之门</p>
      <p class="lj_desc">“华门之巅，威荣之间”，我们是一家集自主设计、研发、生产与营销服<br/>务于一体高新技术型现代化企业</p>
      <a class="lj_btn" @click.prevent="$router.push('comp_index')" href="#">
          <span>了解梵蒂斯 →</span>
      </a>
    </div>

    <!-- 三大快捷入口 -->
    <div class="sandDiv">
      <el-row  :gutter="80" >

        <el-col  :md="6" :xs="24">
          <div class="hmore">
            <img class="hmore_image" src="static/menhu/images/home_ec.webp" />
            <p class="hmore_title1">Engineering Case</p>
            <p class="hmore_title2">工程案例</p>
            <p class="hmore_desc">梵蒂斯经过24年的发展，口碑良好，合作的成功案例也是数不胜数，好的品质是我们的立足之本。</p>
            <el-button class="show_btn" @click="$router.push('caseIndex')" type="primary" plain>了解更多 →</el-button>
          </div>
        </el-col>

        <el-col :md="6" :xs="24">
          <div class="hmore">
            <img class="hmore_image" src="static/menhu/images/home_mj.webp" />
            <p class="hmore_title1">Merchants to Join</p>
            <p class="hmore_title2">招商加盟</p>
            <p class="hmore_desc">“华门之巅，威荣之间”，华威门业为社会各界精英量身定做精良产品，携手共创互赢而美好的未来！</p>
            <el-button class="show_btn" @click="$router.push('join')" type="primary" plain>了解更多 →</el-button>
          </div>
        </el-col>

        <el-col :md="6" :xs="24">
          <div class="hmore">
            <img class="hmore_image" src="static/menhu/images/home_cs.webp" />
            <p class="hmore_title1">Customer Service</p>
            <p class="hmore_title2">客户服务</p>
            <p class="hmore_desc">公司拥有规范的售后服务及流程，无论是咨询问题还是售后问题，梵蒂斯客服都会在规定时间内答复。</p>
            <el-button @click="$router.push('service')" class="show_btn" type="primary" plain>了解更多 →</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 产品工艺 -->
    <div class="goodGyDiv">
      <el-carousel height="860px" direction="vertical" :autoplay="false">
        <el-carousel-item v-for="(item,index) in gyList" :key="index">
          <div class="gy_div">
            <p class="gy_title">{{ item.gyName }}</p>
            <p class="gy_desc">{{ item.gyDesc }}</p>
            <img class="gy_image" :src="$fileDPath+item.gyImg" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>



  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css';
export default {
  name: 'home',
  data() {
    return {
      homeData: {
        banner_video: "",
        guangao_bannsers: [],
        comp_banners: [],
        goods_banner:[
          {
            typeID:"01",
            title:"五色印象",
            desc:"以荷兰后印象派画家“梵高”的艺术创造精神为研发信条，时刻坚守高端产品路线原则",
            images:"https://cdn.jihui88.com/upload//1//16//13282529999//picture//2022//11//01/9f1e5b72-1058-467c-b532-765ff46029bf.png"
          },
          {
            typeID:"02",
            title:"五行奇门",
            desc:"以环境学和风水学为设计根本，以万物五行属性相生相克为原理，创建个性生活空间，满足国内外追求理想主义的顶级消费群体的需求",
            images:"https://cdn.jihui88.com/upload//1//16//13282529999//picture//2022//11//01/71d39dae-b847-4854-9211-7ebc1552d411.png"
          },{
            typeID:"03",
            title:"印象敦煌",
            desc:"在金属的刚硬和力量中，演绎极简设计的优雅与柔情；忠于简单自然的生活态度，呈现你所追求的极简格调，重塑业界顶级制造工艺。",
            images:"https://cdn.jihui88.com/upload//1//16//13282529999//picture//2023//08//07/18646b9b-15f9-4884-b564-a30b424b92d8-1691387097393_img_3_380x380.png"
          },
          {
            typeID:"04",
            title:"高端定制",
            desc:"在金属的刚硬和力量中，演绎极简设计的优雅与柔情；忠于简单自然的生活态度，呈现你所追求的极简格调，重塑业界顶级制造工艺。",
            images:"https://cdn.jihui88.com/upload//1//16//13282529999//picture//2023//09//04/ebe641d2-26ce-441a-b322-f2c9c984c02c-1693817544156_img_4_380x380.png"
          },
          {
            typeID:"05",
            title:"车库门",
            desc:"Silvelox创建了一系列车库门，独特和可以满足不同建筑和美学要求。Secur车库门一直以来都是独领风骚降系统反而天花板导轨。",
            images:"https://cdn.jihui88.com/upload//1//16//13282529999//picture//2024//03//12/72600544-b20f-4daa-8605-e4b1e981afe1-1710204570897_img_5_380x380.png"
          },
          {
            typeID:"06",
            title:"庭院门",
            desc:"将梵高油画中的星璇造型交织相叠，以油画笔触描绘/n璀璨星空，简约直线贯穿平面，表现出丰富的节奏感和层次感。",
            images:"https://cdn.jihui88.com/upload//1//16//13282529999//picture//2024//02//19/216cdc2e-f601-4fd9-8d09-a39ebff1aa1c-1708311004310_img_6_380x380.png"
          },
          {
            typeID:"07",
            title:"智能锁",
            desc:"行业顶尖指纹方案, 如手机般流畅/n自主算法不断深度学习, 适应指纹",
            images:"https://cdn.jihui88.com/upload//1//16//13282529999//picture//2024//07//18/4690522d-0b4b-479f-8425-eeda9d724671-1721266215676_img_7_380x380.png"
          }
        ]
      },
      nowShowGood:{
        typeID:"01",
        title:"五色印象",
        desc:"以荷兰后印象派画家“梵高”的艺术创造精神为研发信条，时刻坚守高端产品路线原则",
        images:"https://cdn.jihui88.com/upload//1//16//13282529999//picture//2022//11//01/9f1e5b72-1058-467c-b532-765ff46029bf.png"
      },
      // 工艺是静态数据
      gyList:[]
    }
  },
  created() {
    this.getHome1Data();
    this.getHome2();
    this.getHome3();
  },
  methods:{
    // 点击跳转路由
    toRouter(routerName){
      this.$router.push({name:routerName});
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 可选，平滑滚动效果
      });
    },
    // 查询视频和广告
    getHome1Data(){
      let _this = this;
      this.$axios.get('/fantis/home1/ftCmsHomeTop/queryById?id=101')
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            if(tempData.bannerVideo!=null && tempData.bannerVideo!=""){
              _this.homeData.banner_video =
                _this.$fileDPath + tempData.bannerVideo;
            }

            var imgs = tempData.guangaoBannsers.split(",");
            for(var i in imgs){
              imgs[i] = _this.$fileDPath + imgs[i];
            }

            _this.homeData.guangao_bannsers = imgs;

          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    // 查询连接轮播
    getHome2(){
      let _this = this;
      this.$axios.get('/fantis/home2/ftCmsHomeLinks/list?pageNo=1&pageSize=999')
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            _this.homeData.comp_banners = tempData.records;

          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    // 查询工艺内容
    getHome3(){
      let _this = this;
      this.$axios.get('/fantis/gy/ftCmsHomeGys/list?pageNo=1&pageSize=999')
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            _this.gyList = tempData.records;

          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },

    // 五行奇门位置鼠标放置上去右侧变化
    changeGoodLink(typeID){
      for(var i in this.homeData.goods_banner){
        if(this.homeData.goods_banner[i].typeID == typeID){
          this.nowShowGood = this.homeData.goods_banner[i];
        }
      }
    }
  }
}
</script>

<style scoped>
.goodsTypeShowDiv{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 5px 10px 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.show_title{
  font-size: 24px;
  margin: 60px 0 25px;
  color: #000;
}
.show_img{

}
.show_desc{
  font-size: 18px;
  margin: 25px 0 30px;
  color: rgba(8, 40, 65, 1);
}
.show_btn{
  width: 178px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 36px;
  text-align: center;
  font-size: 14px;
  color: rgba(8, 40, 65, 1);
  border: 1px rgba(8, 40, 65, 1) solid;
  transition: all .3s;
  -ms-transition: all .3s;
  -moz-transition: all .3s;
  -webkit-transition: all .3s;
  -o-transition: all .3s;
  margin: 0 auto;
}

.show_btn:hover {
  border: none;
  background: rgba(8, 40, 65, 1);
  color: #fff;
}

.videoDiv{
  width: 100%;
}
.videoDiv video{
  width: 100%;
}
.guangaoDiv{
  width: 100%;
  height: 100vh;
}

.linkDiv{
  width: 100%;
  height: 99vh;
  background-color: #082841;
}



.bgDiv{
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  padding-top: 10%;
}

.tit p{
  margin-bottom: 16px;
  font-size: 24px !important;
  line-height: 1.5 !important;
  color: #fff !important;
}

.desc p{
  font-size: 14px !important;
  line-height: 24px !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: lighter !important;
}

.wuxinDiv{
  width: 100%;
  height: 94vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.circle{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle .wrapper {
  position: relative;
  width: 800px;
  height: 800px;
}

.circle .wrapper .center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center;
}

.circle .wrapper .circle-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center;
  background-color: #082841;
  width: 252px;
  height: 252px;
  border-radius: 50%;
}
.circle .wrapper .run {
  width: 800px;
  height: 800px;
  /* border: 1px solid #000; */
  position: relative;
  /* border-radius: 50%; */
  animation: circle 120s linear infinite forwards;
}
ul, ol, li {
  list-style: none;
  padding: 0;
  margin: 0;
}
.run ul li {
  background: radial-gradient(circle, #FFFFFF 0%, #E7EDF3 100%);
  border: 1px solid #F1F1F1;
  border-radius: 50%;
  position: absolute;
  animation: circleback 120s linear infinite forwards;
  text-align: center;
  width: 110px;
  height: 110px;
  line-height: 110px;
}
.run ul li a {
  font-size: 18px;
  text-align: center;
  color: #000;
  display: block;
  width: 100%;
  height: 100%;
}
.item-1 {
  top: 22%;
  left: 4%;
}
.item-2 {
  top: 25%;
  left: 83%;
}
.item-3 {
  top: 87%;
  left: 45%;
}
.item-4 {
  top: 59%;
  left: 18%;
}
.item-5 {
  top: 14%;
  left: 44%;
}
.item-6 {
  top: 60%;
  left: 69%;
}
.item-7 {
  top: 82%;
  left: 66%;
}
.run.on {
  animation-play-state: paused;
}
.run ul li.ons {
  animation-play-state: paused;
}
.run ul li:nth-child(n+4) {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.run ul li:hover {
  animation-play-state: paused;
  background: rgba(8,40,65,1);
  border: none;
}
.run ul li:hover span {
  transform: scale(1.1);
  transform-origin: center;
  transition: all 0.3s;
  color: #fff;
}
.run ul li a img {
  display: block;
  width: 100%;
}
@keyframes circle {
  0% {
    transform:rotate(0);
  }
  100% {
    transform:rotate(360deg);
  }
}
@keyframes circleback {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(-360deg);
  }
}

.ljFantisDiv{
  width: 100%;
  height: 96vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.lj_img{
  margin-bottom: 50px;
}
.lj_title{
  font-size: 36px;
  text-align: center;
  color: #fff;
}
.lj_desc{
  font-size: 16px;
  text-align: center;
  color: #fff;
  line-height: 1.6;
  padding: 0 100px;
  margin-bottom: 50px;
}
.lj_btn{
  width: 238px;
  height: 44px;
  display: block;
  line-height: 44px;
  text-align: center;
  font-size: 14px;
  color: #FFF;
  border: 1px #fff solid;
  transition: all .3s;
  -ms-transition: all .3s;
  -moz-transition: all .3s;
  -webkit-transition: all .3s;
  -o-transition: all .3s;
  margin: 0 auto;
}
.lj_btn:hover {
  border: none;
  background: rgba(8, 40, 65, 1);
}
.sandDiv{
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  padding-left: 18%;
  overflow: hidden;
}
.hmore{
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  padding: 20px 10px;
}
.hmore_image{
  display: block;
  max-width: 100%;
  width: 100%;
  transition: transform 4s cubic-bezier(.075,.82,.165,1);
  -moz-transition: transform 4s cubic-bezier(.075, .82, .165, 1);
  -ms-transition: transform 4s cubic-bezier(.075, .82, .165, 1);
  -webkit-transition: transform 4s cubic-bezier(.075,.82,.165,1);
  -o-transition: transform 4s cubic-bezier(.075, .82, .165, 1);
}
.hmore_title1{
  color: #333;
  font-size: 24px;
  font-family: Montserrat;
  font-weight: 300;
  line-height: 1.583;
  overflow: hidden;
  transition: color 0.4s cubic-bezier(.075,.82,.165,1);
  -moz-transition: color 0.4s cubic-bezier(.075, .82, .165, 1);
  -ms-transition: color 0.4s cubic-bezier(.075, .82, .165, 1);
  -webkit-transition: color 0.4s cubic-bezier(.075,.82,.165,1);
  -o-transition: color 0.4s cubic-bezier(.075, .82, .165, 1);
  margin: 24px 0px 0px 0px;
}
.hmore_title2{
  color: rgba(8, 40, 65, 1);
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 1.583;
  overflow: hidden;
  transition: color 0.4s cubic-bezier(.075,.82,.165,1);
  -moz-transition: color 0.4s cubic-bezier(.075, .82, .165, 1);
  -ms-transition: color 0.4s cubic-bezier(.075, .82, .165, 1);
  -webkit-transition: color 0.4s cubic-bezier(.075,.82,.165,1);
  margin: 0;
}
.hmore_desc{
  color: #333;
  font-size: 15px;
  line-height: 1.5;
  overflow: hidden;
  margin-top: 24px;
}

.goodGyDiv{
  width: 100%;
  height: auto;
  box-sizing: border-box;
  background-color: #F8F8F8;
  position: relative;
}
/deep/ .goodGyDiv .el-carousel__indicators--vertical {
  right: 10%;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
/deep/ .goodGyDiv .el-carousel__indicator--vertical .el-carousel__button {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 10px solid black;
  position: relative;
}

/deep/ .goodGyDiv .el-carousel__button::after{
  content: "";
  display: block;
  height: 35px;
  width: 0;
  border: 2px solid darkgray;
  position: absolute;
  top: 10px;
  left: -2px;
}
/deep/ .goodGyDiv .el-carousel__button::before{
  content: "";
  display: block;
  height: 39px;
  width: 0;
  border: 2px solid darkgray;
  position: absolute;
  bottom: 10px;
  left: -2px;
}

/deep/ .goodGyDiv .el-carousel__indicator--vertical {
  padding: 37px 12px;
}
.gy_div{
  width: 80%;
  height: 80%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  position: relative;
}
.gy_title{
  font-size: 24px;
  text-align: center;
  color: #333;
  margin-top: 100px;
  margin-bottom: 30px;
  position: absolute;
  top: -9%;
  z-index: 20;
}
.gy_desc{
  font-size: 16px;
  text-align: center;
  color: #000;
  line-height: 1.6;
  padding: 0 1.5vw;
  position: absolute;
  top: 10%;
  z-index: 20;
}
.gy_image{
  width: 75%;
}

@media only screen and (max-width: 800px) {
  /* 针对移动设备的样式 */
  .linkDiv {
    height: auto; /* 高度自适应内容 */
    width: 100%;  /* 宽度占满屏幕 */
  }

  /deep/ .guangaoDiv .el-carousel__container{
    height: 200px !important;
  }

  /deep/ .linkDiv .el-carousel__container{
    height: 450px !important;
  }

  .guangaoDiv{
    width: 100%;
    height: auto;
  }

  .wuxinDiv{
    width: 100%;
    height: 80vh;
  }

  .sandDiv{
    display: flex;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    padding-left: 0%;
    overflow: hidden;
  }

  .gy_image{
    max-width: 1800px !important;
    width: 500px;
  }

  .show_img{
    width: 65vw;
  }

  .gy_desc{
    top:14%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/home.vue